import styled from "@emotion/styled";

const StyledProductSidebarSkeleton = styled.div`
  .labels {
    display: flex;
    height: 20px;
  }

  .label1 {
    width: 67px;
  }

  .label2 {
    margin-left: 8px;
    width: 80px;
  }

  .brandName {
    margin-top: 24px;
    height: 26px;
    width: 120px;
  }

  .productName {
    margin-top: 8px;
    width: 234px;
    height: 24px;
  }

  .price {
    margin-top: 18px;
    width: 104px;
    height: 24px;
  }

  .order {
    margin-top: 16px;
    height: 164px;
    width: 100%;
  }

  .meta {
    margin-top: 40px;
    height: 55px;
    width: 100%;
  }

  .meta + .meta {
    margin-top: 8px;
  }

  .buttons {
    margin-top: 24px;
    display: flex;
    height: 42px;
  }

  .button {
    width: 120px;
  }

  .button + .button {
    margin-left: 16px;
  }
`;

export { StyledProductSidebarSkeleton };
